export const isVideoType = (uri) => {
    if (['.mp4', '.mov'].some(extension => uri.endsWith(extension))) {
        return true;
    }
    else {
        return false;
    }
}

// add type as well if/when support for other than mp4 is needed
export const defaultVideoJSOptions = (src) => {

    return {
        autoplay: false,
        preload: 'metadata',
        controls: true,
        height: 'auto',
        width: 'auto',
        sources: [{
            src: src,
            type: 'video/mp4'
        }]
    }
}